import React from 'react'
import Information from '../public/Information/Information'
import ManuOperation from './navOperationRoom/ManuOperation'

function RelatedinfoLaboratory() {
    return (
        <div>
            <ManuOperation menuActive={'relatedinfo'} />
            <Information type={'laboratory'}/>
        </div>
    )
}

export default RelatedinfoLaboratory